///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, salesControlActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'

const getSalesControl = function* ({ payload }) {
	const bodyMsg = payload.filters
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_SALES_CONTROL(user['idUser'], payload.queryParams)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).post(apiCall, bodyMsg)
		yield put(salesControlActionCreators.getSalesControlSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(salesControlActionCreators.getSalesControlFailure(e.response))

		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_SALES_CONTROL, getSalesControl)
}

export default sagas
